import React from 'react'
import PropTypes from 'prop-types'
import { Description } from 'LiveBoard/components/desktop/shared/Item'
import { getItemTypeConfig, ItemType } from 'LiveBoard/components/shared/ItemType'
import { Interactions } from 'LiveBoard/components/shared/Interactions'
import { SmartImage } from 'shared/UI/SmartImage'
import { DummyAnchorTag } from 'LiveBoard/components/shared/DummyAnchorTag'
import { triggerClickOnEnter, ACCESSIBILITY_CLASSES, TAB_INDEXES } from 'shared/helpers/AccessibilityHelper'

import './style.css.scss'

const ItemTile = (props) => {
  const {
    item, themeColorHex, onClick, showViews, showLikes, showItemType,
    showItemDescription, getItemUrl
  } = props
  const itemTypeConfig = getItemTypeConfig(item)
  const handleClick = () => onClick(item.id)

  const itemRoute = getItemUrl ? getItemUrl(item.id) : ''

  return (
    <div
      className={`item-tile ${ACCESSIBILITY_CLASSES.main}`}
      onClick={handleClick}
      onKeyDown={triggerClickOnEnter}
      role="button"
      tabIndex={TAB_INDEXES.ItemTile}
      aria-label={item.description}
    >
      { itemTypeConfig.isVideo && <span className="icon-play-button" /> }
      <div className="item-tile-image-wrapper">
        <SmartImage
          config={item.image}
          tabIndex={TAB_INDEXES.ItemTileImage} />
      </div>
      <div className="item-tile-information">
        { (showViews || showLikes) &&
          <Interactions
            likesCount={item.likes_count}
            viewsCount={item.views_count}
            showViews={showViews}
            showLikes={showLikes} />
        }
        { !!showItemType &&
          <ItemType item={item} />
        }
      </div>
      <div className="item-title">
        <DummyAnchorTag url={itemRoute} tabIndex={TAB_INDEXES.ItemTileDummyAnchorTag}>{item.name}</DummyAnchorTag>
      </div>
      { showItemDescription &&
        <Description
          themeColorHex={themeColorHex}
          item={item}>
          <p>{item.description || item.name}</p>
        </Description>
      }
    </div>
  )
}

ItemTile.propTypes = {
  item: PropTypes.object.isRequired,
  themeColorHex: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  showViews: PropTypes.bool,
  showLikes: PropTypes.bool,
  showItemType: PropTypes.bool,
  showItemDescription: PropTypes.bool,
  getItemUrl: PropTypes.func
}

export default ItemTile
